import React from 'react';

import { connect } from 'react-redux';
import cx from 'classnames';
import { fetchReviewsTotal } from '../../ducks/reviews';

import StarRating from './stars/StarRating';
import ChannelLink from '../../containers/channelUtils/ChannelLink';

import './ReviewsTotal.sass';

@connect(({ reviews }) => ({ reviewsTotal: reviews.total }))
export default class ReviewsTotal extends React.PureComponent {
  static fetchData = ({ dispatch, reviewsTotal }) => reviewsTotal === undefined && dispatch(fetchReviewsTotal());

  componentDidMount() {
    ReviewsTotal.fetchData(this.props);
  }

  componentDidUpdate() {
    ReviewsTotal.fetchData(this.props);
  }

  render() {
    const { reviewsTotal, vertical } = this.props;

    if (this.props.isHeaderVariant) {
      return (
        <ChannelLink to="/reviews" className={cx('reviews-total', 'reviews-total--header', vertical && 'reviews-total--vertical')}>
          <span className="reviews-total__text">Excellent</span>
          <span className="reviews-total__stars">
            <StarRating value={5} size={18} />
          </span>
          <span className="reviews-total__text">
            <span className="reviews-total__count">4.9</span> out of 5 based on <span className="reviews-total__count">{reviewsTotal}</span> reviews
          </span>
        </ChannelLink>
      );
    }

    return (
      <ChannelLink to="/reviews" className={cx('reviews-total', vertical && 'reviews-total--vertical')}>
        <span className="reviews-total__stars">
          <StarRating value={5} size={20} />
        </span>
        <span className="reviews-total__text">
          Based on <span className="reviews-total__count">{reviewsTotal}</span> reviews
        </span>
      </ChannelLink>
    );
  }
}



// WEBPACK FOOTER //
// ./components/reviews/ReviewsTotal.js